import { axiosRequestGET } from './serviceConfig';

export const getDashboardAccessService = (id) => axiosRequestGET(`/api/editor/knowledge/${id}/dashboard-access`);

export const getAreasAccessService = () => axiosRequestGET('/api/editor/knowledge');